import { getCookieConsentValue } from "react-cookie-consent"

export const onRouteUpdate = ({ location }) => {
  // See also cookie-consent.tsx.
  if (getCookieConsentValue() === "true") {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: "page_load_with_consent",
      path: location.pathname,
    })
  }
}
